import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class UpdateReferral {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * UpdateReferral constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Update referral in the backend.
     *
     * @param {Number} id
     *
     * @returns {Promise}
     */
    handle(id) {
        return this.apiService
            .patch(url(ApiEndpoints['users.referral.update'], [id]), {});
    }
}
